import { render, staticRenderFns } from "./FootInfo.vue?vue&type=template&id=21c06d30&scoped=true"
import script from "./FootInfo.vue?vue&type=script&lang=js"
export * from "./FootInfo.vue?vue&type=script&lang=js"
import style0 from "./FootInfo.vue?vue&type=style&index=0&id=21c06d30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c06d30",
  null
  
)

export default component.exports